import { Box, Stack, Grid } from "@mui/material";
import React, { useState } from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { BSSConfirmDialog} from "../../../form/BSSDialog";
const {logger} = useBSSLogger();

const DialogFiltroStatoOrdine = ({stati, filtri, setFiltri, dialogFiltriStati, setDialogFiltriStati}) => {

    const [filtriStati, setFiltriStati] = useState([]);

    const aggiornaFiltriStati = (id) => {
        
        const filtriAttuali = filtriStati ?? [];

        setFiltriStati(
            filtriAttuali.includes(id) ? filtriAttuali.filter(s => s !== id) : [...filtriAttuali, id]
        )
    }

    const filtraPerStati = (listaStati = []) => {
        let nuoviFiltri = {};
        if(Array.isArray(listaStati) && listaStati.length > 0){
            nuoviFiltri.stati = listaStati
        }

        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                ...nuoviFiltri
            }, 
            skip: 0
        });
        setFiltriStati([])
        setDialogFiltriStati({mostra: false})
    }

    const filtriStatiAttuali = filtriStati ?? [];

    return (
        <BSSConfirmDialog
            title={__t("mostrasoloinstato")}                                                        
            open={dialogFiltriStati.mostra} 
            undoAction={e => setDialogFiltriStati({mostra: false})} 
            confirmAction={e => {
                filtraPerStati(filtriStati)
            }}
            sx={{"& .MuiDialogContent-root": {p: 0}, maxHeight: "450px"}}
        >
            {<Stack>
                {Object.values(stati).map((stato => {                    

                    const Icon = filtriStatiAttuali.includes(stato.id) ? CheckBox : CheckBoxOutlineBlank

                    return (
                        <Box key={stato.id} pl={1} my={1} mr={1} sx={{w: 1}}>

                            <Grid container direction="row" alignItems="center" sx={{
                                p: 0.2,
                                cursor : "pointer",
                                backgroundColor: stato.colorestato,
                                color: stato.coloretesto,                                                                                                                                                           
                            }}  onClick={e => aggiornaFiltriStati(stato.id)} >
                                <Grid item>
                                    <Icon />
                                </Grid>
                                <Grid item>
                                    {stato.codicestato}
                                </Grid>
                            </Grid>
                        </Box>
                    )
                }))}
            </Stack>}
            {/* <ReactJson src={stati} /> */}


        </BSSConfirmDialog>
    )
}

export default DialogFiltroStatoOrdine